import "@fpsm/cxy-tokens/tokens.css?__remix_sideEffect__";

import { type FooterV2Response } from '~/interfaces/HeaderFooterNavV2';

import FooterGeneralLinks from './components/FooterGeneralLinks';
import FooterNav from './components/FooterNav';
import FooterSocialsAndDisclaimer from './components/FooterSocialsAndDisclaimer';
import styles from './FooterV2.module.css';

export const FooterV2 = ({
  footerData,
  resourcesUrl



}: {footerData: FooterV2Response;resourcesUrl: string;}) => {
  if (!footerData) return null;

  const { levelOne, levelThree, levelTwo } = footerData;

  return (
    <footer className={styles.footerContainer} data-testid="footer-v2">
			<FooterNav categoryGroups={levelOne} />
			<FooterSocialsAndDisclaimer
        resourcesUrl={resourcesUrl}
        socialsAndDisclaimerData={levelTwo} />

			<FooterGeneralLinks generalLinks={levelThree} />
		</footer>);

};